export enum OfferConfirmAction {
  /** A draft – never sent, so it is deleted. */
  DELETE = 'DELETE',
  /** A sent offer – its link stops working, it stays as revoked. */
  REVOKE = 'REVOKE',
  /** A closed offer (accepted, revoked, expired) – moves to the read-only archive. */
  ARCHIVE = 'ARCHIVE'
}
